import { CommissionRateColumn as CommissionRateColumnConfig } from '@bingads-webui-campaign/ad-groups-data';
import { BidBaseColumn, commonBidStrategyListToDisableBidAmountEdit } from './bid-base-column';

export class CommissionRateColumn extends BidBaseColumn {
  constructor({ i18n, view, isForVNext }) {
    super({
      ...CommissionRateColumnConfig,
      sortable: 'CommissionRate/RateAmount/Amount',
      title: i18n.getString('ColumnName_CommissionRate'),
      i18n,
      view,
      bidStrategyListToDisableBidAmountEdit: commonBidStrategyListToDisableBidAmountEdit(['Commission']),
      isForVNext,
    });
  }
}
